import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import { IconArrowUp01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** onClick */
  onClick?: () => void;
}

const TopBtn = ({ className, onClick }: IProps) => {
  const cName = classNameBind(['top-btn', className || '']);

  return (
    <S.TopBtn
      className={cName}
      onClick={onClick}
      label="페이지 맨위로 이동"
      icon={<IconArrowUp01 />}
    />
  );
};

export default TopBtn;
